import { api, extractResponseData } from "./base";

export const dashboardService = {
  getPlatformIdentityOverview: async () => {
    try {
      const response = await api.get("/platform/identity-overview");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching dashboard overview:", error);
      throw new Error(`Failed to fetch dashboard data: ${error.message}`);
    }
  },
  searchUsers: async (filters) => {
    try {
      const response = await api.post("/platform/users/search", filters);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in searching platform users:", error);
      throw new Error(`Failed to search users: ${error.message}`);
    }
  },
  searchAccounts: async (filters) => {
    try {
      const response = await api.post("/platform/accounts/search", filters);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in searching platform accounts:", error);
      throw new Error(`Failed to search accounts: ${error.message}`);
    }
  },
  searchReaderProfiles: async (filters) => {
    try {
      const response = await api.post("/platform/readers/search", filters);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in searching reader profiles:", error);
      throw new Error(`Failed to search reader profiles: ${error.message}`);
    }
  },
  getReadingObjectives: async () => {
    try {
      const response = await api.get("/platform/reading-objectives");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching reading objectives:", error);
      throw new Error(`Failed to fetch reading objectives: ${error.message}`);
    }
  },
  getAvatars: async () => {
    try {
      const response = await api.get("/platform/avatars/active");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching active avatars:", error);
      throw new Error(`Failed to fetch active avatars: ${error.message}`);
    }
  },
  getDeviceStats: async () => {
    try {
      const response = await api.get("/platform/devices/stats");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching device stats:", error);
      throw new Error(`Failed to fetch device stats: ${error.message}`);
    }
  },
  broadcastPushCampaign: async (payload) => {
    try {
      const response = await api.post("/platform/devices/broadcast", payload);
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in broadcasting push campaign:", error);
      throw new Error(`Failed to broadcast push campaign: ${error.message}`);
    }
  },
  getMonetizationStats: async () => {
    try {
      const response = await api.get("/platform/monetization/stats");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching monetization stats:", error);
      throw new Error(`Failed to fetch monetization stats: ${error.message}`);
    }
  },
  searchPurchaseOrders: async (filters) => {
    try {
      const response = await api.post(
        "/platform/monetization/orders/search",
        filters,
      );
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in searching purchase orders:", error);
      throw new Error(`Failed to search purchase orders: ${error.message}`);
    }
  },
  getMonetizationProducts: async () => {
    try {
      const response = await api.get("/platform/monetization/products");
      return extractResponseData(response);
    } catch (error) {
      console.error("Error in fetching monetization products:", error);
      throw new Error(
        `Failed to fetch monetization products: ${error.message}`,
      );
    }
  },
  getOrderReceipt: async (orderId) => {
    try {
      const response = await api.get(
        `/platform/monetization/orders/${orderId}/receipt`,
      );
      return extractResponseData(response);
    } catch (error) {
      console.error(`Error in pulling order receipt for ${orderId}:`, error);
      throw new Error(`Failed to fetch order receipt: ${error.message}`);
    }
  },
  getReaderStats: async (readerProfileId) => {
    try {
      const response = await api.get(
        `/platform/readers/${readerProfileId}/stats`,
      );
      return extractResponseData(response);
    } catch (error) {
      console.error(
        `Error in fetching reader stats for ${readerProfileId}:`,
        error,
      );
      throw new Error(`Failed to fetch reader stats: ${error.message}`);
    }
  },
};
